import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { LeadService } from 'src/app/private/services/lead.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';

@Component({
  selector: 'app-lead-tasks',
  templateUrl: './lead-tasks.component.html',
  styleUrls: ['./lead-tasks.component.scss']
})
export class LeadTasksComponent {

  @Output() close = new EventEmitter<void>();
  @Output() reloadLeadList = new EventEmitter<void>();
  @Input() editFieldValues: any;
  btnLoading = false;
  leadTaskList: any[] = [];
  loading = false;
  editTaskData: any;

  constructor(private toaster: ToastrService,
    private api: LeadService,
    private localstorage: LocalStorageService,
    private modalService: NgbModal,
    private tracker: TrackingService
  ) { }

  ngOnInit() {
    this.getLeadTasks();
  }

  getLeadTasks() {
    this.loading = true;

    const payload = {
      "client_id": this.localstorage.getClientId(),
      "lead_id": this.editFieldValues.lead_id,
    }

    this.api.getAllTasks(payload).subscribe({
      next: (res) => {
        this.leadTaskList = res || [];
        this.loading = false;
         // ✅ Track task list viewing
        const desc = `Viewed tasks for lead ID: ${payload.lead_id}`;
        this.tracker.track('View', 'Lead Tasks', desc);
      },
      error: (err) => {
        this.toaster.error(err.error.message || 'Something went wrong');
        this.loading = false;
      }
    });
  }


  closeModal() {
    this.close.emit();
  }

  openModal(content: any) {
    this.modalService.open(content, { size: 'lg', scrollable: true, centered: true });
     // ✅ Track opening add task modal
    const desc = `Opened add task modal for lead ID: ${this.editFieldValues.lead_id}`;
    this.tracker.track('Open Modal', 'Add Lead Task', desc);
  }

  openModalEdit(content: any, data: any) {
    this.editTaskData = data;
    this.modalService.open(content, { size: 'lg', scrollable: true, centered: true });
     // ✅ Track opening edit modal
    const desc = `Opened edit modal for task ID: ${data?.task_id}`;
    this.tracker.track('Open Modal', 'Edit Lead Task', desc);
  }

  openModalDelete(content: any, data: any) {
    this.editTaskData = data;
    this.modalService.open(content, { size: 'md', scrollable: true, centered: true });
     // ✅ Track opening delete modal
    const desc = `Opened delete modal for task ID: ${data?.task_id}`;
    this.tracker.track('Open Modal', 'Delete Lead Task', desc);
  }


  reload() {
    this.getLeadTasks();
    this.reloadLeadList.emit();
  }

  handleDeleteTask(model: any) {
    this.btnLoading = true;

    const payload = {
      "client_id": this.localstorage.getClientId(),
      "task_id": this.editTaskData.task_id,
    }

    this.api.deleteTask(payload).subscribe({
      next: (res) => {
        this.toaster.success(res.message || 'Task deleted successfully');
        this.btnLoading = false;
        this.reload();
        model.dismiss('Cross click')
          // ✅ Track task deletion
        const desc = `Deleted task ID: ${payload.task_id}`;
        this.tracker.track('Delete', 'Lead Task', desc);
      },
      error: (err) => {
        this.toaster.error(err.error.message || 'Something went wrong');
        this.btnLoading = false;
      }
    });
  }
}
